import axios from 'axios';
import { BasicStructure } from '../Interfaces';
import { getProductBrandEndpoint } from '../Endpoints';
import { getDefaultHeaders } from '../Utils';

export const getProductBrands = async (token: string, managementId: string): Promise<BasicStructure[]> => {
    try{
        const {data, status} = await axios.get(getProductBrandEndpoint, getDefaultHeaders(token, managementId));
        if (status === 200 && data?.Ok){
            const result:BasicStructure[] = data.Data;
            return result;
        }

        return [];
    }
    catch {
        return [];
    }
}